
/**
 * 判断多选条件是否存在
 * @param text 
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const IsExist = (list, condition) => {
    if (!condition) return false
    let result = false
    let codeAndRow = condition.split(':')[0] // 试题号、行号
    let num = condition.split(':')[1]
    let orderNumArr = condition.split(':')[2].split(',')
    let code = codeAndRow.split('_')[0] // 试题编码
    let sonOrderNum = codeAndRow.split('_').length > 1 ? codeAndRow.split('_')[1] : undefined // 行编号
    // console.log('orderNumArr, code,sonOrderNum, num :>> ', orderNumArr, code,sonOrderNum, num);
    list.forEach(info => {
        if (code == info.quesCode && info.bindIsShow && info.isShow) {
            let selectedNum = 0 // 答案中已选的个数
            switch(info.questionsTypeId) {
                case '10': // 多选
                    info.optionList.forEach(op => {
                        if (orderNumArr.indexOf(op.orderNum.toString()) != -1 
                            && info.userAnswerArr.indexOf(op.oid) != -1
                        ) {
                            selectedNum++
                        }
                    })
                    if (selectedNum >= num) {
                        result = true
                    }
                    break
                case '20': // 矩阵多选
                    info.questionsSonList.forEach(son => {
                        if (sonOrderNum == son.orderNum) {
                            son.optionList.forEach(op => {
                                // console.log('info.userAnswerArr :>> ', info.userAnswerArr)
                                if (orderNumArr.indexOf(op.orderNum.toString()) != -1 && 
                                    info.userAnswerArr.length > 0 &&
                                    info.userAnswerArr[son.orderNum - 1].value.indexOf(op.oid) != -1
                                ) {
                                    selectedNum++
                                }
                            })
                        }
                    })
                    if (selectedNum >= num) {
                        result = true
                    }
                    break
            }
        } 
        // else if (code == info.quesCode && (!info.bindIsShow || !info.isShow)){
        //     result = true
        // }
    })
    return result;
}